/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useMemo } from 'react';

import { Box, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core';
import { CheckCircle, InsertDriveFile } from '@material-ui/icons';

import { ReactComponent as DcmIcon } from '../../assets/images/dcm.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/delete.svg';
import { ReactComponent as EditIcon } from '../../assets/images/edit.svg';
import { ReactComponent as ImageAssetIcon } from '../../assets/images/imageAsset.svg';
import { ReactComponent as ThreeAssetIcon } from '../../assets/images/threeAsset.svg';
import { ReactComponent as VideoAssetIcon } from '../../assets/images/videoAsset.svg';
import { ReactComponent as ViewIcon } from '../../assets/images/view.svg';
import { DCM, DOCS, IMAGE, SELFHELP, THREE, VIDEO, resourcePrivacy } from '../../models/Resource';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles((theme) => {
  return {
    button: {
      background: 'none',
      border: 'none',
      outline: 'none',
    },
    buttonSelect: {
      border: '1px solid #FFF !important',
      marginTop: '8px',
      padding: '4px',
      width: '100%',
    },
    container: {
      '&:hover': {
        '& $overlay': {
          height: '100%',
          opacity: 1,
        },
      },
      backgroundSize: 'cover',

      border: '1px solid #E7E7E7',
      borderRadius: '5px',
      height: '164px',
      marginBottom: '0.5rem',
      minWidth: '70px',
      position: 'relative',
    },
    containerSelected: {
      border: '3px solid #43a047',
    },

    dicomText: {
      color: '#2AAAE2',
      fontSize: '40px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      lineHeight: '47px',
    },
    icon: {
      '&:hover': {
        fill: theme.palette.primary.main,
      },
      cursor: 'pointer',
      fill: 'white',
      width: '30px',
    },
    iconDisabled: {
      cursor: 'not-allowed',
      fill: '#AAA !important',
    },
    label: {
      overflowWrap: 'break-word',
      textOverflow: 'ellipsis',
      whiteSpace: 'wrap',
    },
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.7)',
      borderRadius: '5px',
      bottom: '0',
      height: '0%',
      left: '0',
      opacity: '0',
      position: 'absolute',
      right: '0',
      top: '0',
      transition: 'height.5s ease, opacity 0.25s ease',
      width: '100%',
      zIndex: '1',
    },
    selectable: {
      cursor: 'pointer',
    },
    selectedIndicator: {
      color: '#43a047',
    },
    selectedIndicatorContainer: {
      bottom: '10px',
      fontSize: '20px',
      left: '10px',
      position: 'absolute',
    },

    typeIndicator: {
      alignItems: 'center',
      background: theme.palette.primary.main,
      borderRadius: '5px',
      display: 'flex',
      height: '35px',
      justifyContent: 'center',
      left: '10px',
      position: 'absolute',
      top: '10px',
      width: '35px',
      zIndex: '2',
    },
  };
});
const ResourceItem = ({
  material,
  onEditMaterial,
  onDeleteMaterial,
  onViewMaterial,
  loading = false,
  isSelectable = false,
  onSelectMaterial,
  disableDeleteButton,
  disableEditButton,
  isSelected = false,
  isTechQA = false,
  privacy,
}) => {
  const classes = useStyles();
  const imageUrl = material?.resource?.customThumbnailPath || material?.thumbnailPath;
  const getImageIcon = () => {
    switch (material?.type) {
      case IMAGE:
        return <ImageAssetIcon />;
      case THREE:
        return <ThreeAssetIcon />;
      case VIDEO:
        return <VideoAssetIcon />;
      case DCM:
        return <DcmIcon />;
      case DOCS:
        return (
          <span style={{ color: '#FFFFFF' }}>
            <InsertDriveFile color="inherit" />
          </span>
        );
      default:
        break;
    }
    return null;
  };
  const thumbnailStyles = !imageUrl
    ? {
        alignItems: 'center',
        background: '#172B4D',
        color: '#2AAAE2',
        display: 'flex',
        justifyContent: 'center',
      }
    : {
        backgroundImage: `url(${imageUrl}`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      };

  const selectedContainerClasses = useMemo(() => {
    const classArray = [classes.container];
    if (isSelected) {
      classArray.push(classes.containerSelected);
    }

    return classArray.join(' ');
  }, [isSelected, classes]);

  const handleMaterialClick = () => {
    if (!onSelectMaterial || typeof onSelectMaterial !== 'function' || !isSelectable) return;
    onSelectMaterial(material);
  };

  return (
    <div>
      <div className={selectedContainerClasses} style={thumbnailStyles}>
        {material?.type === DCM && !imageUrl && <Typography className={classes.dicomText}>Imaging</Typography>}
        {material?.type === DOCS && !imageUrl && <Typography className={classes.dicomText}>Document</Typography>}
        {material?.type === THREE && !imageUrl && <Typography className={classes.dicomText}>3D Model</Typography>}

        <div className={`${classes.typeIndicator}`}>{getImageIcon()}</div>
        {isSelected ? (
          <div className={classes.selectedIndicatorContainer}>
            <CheckCircle className={classes.selectedIndicator} />
          </div>
        ) : null}

        <Grid container className={classes.overlay} justify="center" alignItems="center">
          <Box justify="center" width="60%" alignItems="center" justifyContent="center">
            <Box display="flex" justifyContent="center" alignItems="center" gridGap={8}>
              {loading ? (
                <CircularProgress />
              ) : (
                <button className={classes.button} type="button" onClick={onViewMaterial}>
                  <ViewIcon className={classes.icon} />
                </button>
              )}

              {!(isTechQA && privacy === resourcePrivacy.GLOBAL) && (
                <button disabled={disableEditButton} className={classes.button} type="button" onClick={onEditMaterial}>
                  <EditIcon className={`${classes.icon} ${disableEditButton && classes.iconDisabled}`} />
                </button>
              )}

              {!(isTechQA && privacy === resourcePrivacy.GLOBAL) && (
                <button disabled={disableDeleteButton} className={classes.button} type="button" onClick={onDeleteMaterial}>
                  <DeleteIcon className={`${classes.icon} ${disableDeleteButton && classes.iconDisabled}`} />
                </button>
              )}
            </Box>

            {isSelectable && (
              <button
                onClick={handleMaterialClick}
                className={`${classes.button} ${classes.buttonSelect} ${isSelectable && classes.selectable}`}
                style={{ color: '#FFF' }}
                type="button">
                {isSelected ? 'Unselect' : 'Select'}
              </button>
            )}
          </Box>
        </Grid>
      </div>

      <SimpleTooltip disabled={!material?.description} title={material?.description || ''} placement="bottom">
        <Typography onClick={handleMaterialClick} className={`field-label text-left ${isSelectable && classes.selectable} ${classes.label}`}>
          {material.title}
        </Typography>
      </SimpleTooltip>

      {material.patientNameGender && (
        <Typography onClick={handleMaterialClick} className={`field-label text-left ${isSelectable && classes.selectable}`}>
          {material.patientNameGender}
        </Typography>
      )}
      {material.dateOfBirth && (
        <Typography onClick={handleMaterialClick} className={`field-label text-left ${isSelectable && classes.selectable}`}>
          DOB: {material.dateOfBirth}
        </Typography>
      )}
      {material.studyDateTime && (
        <Typography onClick={handleMaterialClick} className={`field-label text-left ${isSelectable && classes.selectable}`}>
          {material.studyDateTime}
        </Typography>
      )}
      {material.category === SELFHELP && material?.selfHelpCategory && (
        <Typography onClick={handleMaterialClick} className={`field-label text-left ${isSelectable && classes.selectable}`}>
          Category: {material.selfHelpCategory.name}
        </Typography>
      )}
    </div>
  );
};

export default ResourceItem;
